type ExportContext = 'Lookup' | 'Report';

const toPascalAlphaNumeric = (value: string): string => {

    const normalized = value
        .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
        .replace(/[^a-zA-Z0-9]+/g, ' ')
        .trim();

    if (!normalized) {

        return 'Export';

    }

    return normalized
        .split(/\s+/)
        .filter(Boolean)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join('');

};

const getTimestamp = (date = new Date()): string => {

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}_${hours}${minutes}`;

};

export const buildExportFileName = (
    context: string,
    entity: string,
    extension?: string
): string => {

    const normalizedContext: ExportContext =
    context?.toLowerCase() === 'report' ? 'Report' : 'Lookup';
    const normalizedEntity = toPascalAlphaNumeric(entity);
    const baseName = `GMetrix_${normalizedContext}_${normalizedEntity}_${getTimestamp()}`;

    if (!extension) {

        return baseName;

    }

    const normalizedExtension = extension.startsWith('.')
        ? extension
        : `.${extension}`;
    return `${baseName}${normalizedExtension}`;

};
